<template>
  <div class="date-energy">
    <title-one class="m-top" :title="dateEnergyConsumption.title || ''" :ps-txt="dateEnergyConsumption.ps_title || ''" />
    <div class="rank-two left">
      <wh-echarts :id="'ringThree'" :option="ringThree" />
      <ring-center class="center-one" :color="'#eb6060'" :num="mTotal" />
      <ring-center class="center-two" :color="'#ffcb3a'" :num="qTotal" />
      <ring-center class="center-three" :color="'#35e8ce'" :num="yTotal" />
      <span class="ring-name ring-one">月</span>
      <span class="ring-name ring-two">季度</span>
      <span class="ring-name ring-three">年</span>
    </div>
  </div>
</template>

<script>
import TitleOne from '@/components/TitleOne/TitleOne'
import WhEcharts from '@/components/WhEcharts/WhEcharts'
import RingCenter from '@/views/Home/components/RingCenter'
import { spotN } from '@/utils/tool'
export default {
  name: 'DateEnergy',
  components: { RingCenter, WhEcharts, TitleOne },
  props: {
    dateEnergyConsumption: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      mTotal: 0,
      qTotal: 0,
      yTotal: 0,
      ringThree: {
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)'
        },
        legend: {
          orient: 'vertical',
          top: 20,
          left: 10,
          data: ['电力', '天然气', '煤炭', '其他'],
          textStyle: {
            color: '#fff'
          }
        },
        series: [
          {
            name: '月',
            type: 'pie',
            radius: ['50%', '60%'],
            center: ['20%', '45%'],
            avoidLabelOverlap: false,
            label: {
              show: true,
              padding: [0, -20],
              formatter: (params) => {
                return (params.data.selected || false) ? [
                  `{num|${params.data.value}tec}`,
                  '{hr|}',
                  `{title|${params.data.name} ${params.percent}%}`
                ].join('\n') : ''
              },
              rich: {
                title: {
                  align: 'center',
                  height: 23
                },
                hr: {
                  borderColor: '#fff',
                  width: '100%',
                  borderWidth: 1,
                  height: 0
                },
                num: {
                  height: 23,
                  align: 'center'
                }
              }
            },
            itemStyle: { // 此配置
              normal: {
                borderWidth: 4,
                borderColor: '#001124'
              },
              emphasis: {
                borderWidth: 0,
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            data: []
          },
          {
            name: '季度',
            type: 'pie',
            radius: ['50%', '60%'],
            center: ['50%', '45%'],
            avoidLabelOverlap: false,
            label: {
              show: true,
              padding: [0, -20],
              formatter: (params) => {
                return (params.data.selected || false) ? [
                  `{num|${params.data.value}tec}`,
                  '{hr|}',
                  `{title|${params.data.name} ${params.percent}%}`
                ].join('\n') : ''
              },
              rich: {
                title: {
                  align: 'center',
                  height: 23
                },
                hr: {
                  borderColor: '#fff',
                  width: '100%',
                  borderWidth: 1,
                  height: 0
                },
                num: {
                  height: 23,
                  align: 'center'
                }
              }
            },
            itemStyle: { // 此配置
              normal: {
                borderWidth: 4,
                borderColor: '#001124'
              },
              emphasis: {
                borderWidth: 0,
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            data: []
          },
          {
            name: '年',
            type: 'pie',
            radius: ['50%', '60%'],
            center: ['80%', '45%'],
            avoidLabelOverlap: false,
            label: {
              show: true,
              padding: [0, -20],
              formatter: (params) => {
                return (params.data.selected || false) ? [
                  `{num|${params.data.value}tec}`,
                  '{hr|}',
                  `{title|${params.data.name} ${params.percent}%}`
                ].join('\n') : ''
              },
              rich: {
                title: {
                  align: 'center',
                  height: 23
                },
                hr: {
                  borderColor: '#fff',
                  width: '100%',
                  borderWidth: 1,
                  height: 0
                },
                num: {
                  height: 23,
                  align: 'center'
                }
              }
            },
            itemStyle: { // 此配置
              normal: {
                borderWidth: 4,
                borderColor: '#001124'
              },
              emphasis: {
                borderWidth: 0,
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            data: []
          }
        ],
        color: ['#eb6060', '#35e8ce', '#ffcb3a', '#2085e4']
      },
      timer: null
    }
  },
  watch: {
    dateEnergyConsumption: {
      handler(newV, oldV) {
        this.mTotal = spotN((newV.data.m || []).reduce((total, item) => total + (parseFloat(item) || 0), 0))
        this.qTotal = spotN((newV.data.q || []).reduce((total, item) => total + (parseFloat(item) || 0), 0))
        this.yTotal = spotN((newV.data.y || []).reduce((total, item) => total + (parseFloat(item) || 0), 0))
        this.ringThree.legend.data = newV.data.legend || ['电力', '天然气', '煤炭', '其他']
        const data1 = (newV.data.legend || ['电力', '天然气', '煤炭', '其他']).map((item, index) => ({
          value: (newV.data.m || [])[index] || 0,
          name: item,
          selected: false
        }))
        const data2 = (newV.data.legend || ['电力', '天然气', '煤炭', '其他']).map((item, index) => ({
          value: (newV.data.q || [])[index] || 0,
          name: item
        }))
        const data3 = (newV.data.legend || ['电力', '天然气', '煤炭', '其他']).map((item, index) => ({
          value: (newV.data.y || [])[index] || 0,
          name: item
        }))
        this.ringThree.series[0].data = this.flushData(data1)
        this.ringThree.series[1].data = this.flushData(data2)
        this.ringThree.series[2].data = this.flushData(data3)
        clearInterval(this.timer)
        this.timer = setInterval(() => {
          const index = Math.floor(Math.random() * 4)
          this.ringThree.series[0].data = this.flushData(this.randomData(data1, index))
          this.ringThree.series[1].data = this.flushData(this.randomData(data2, index))
          this.ringThree.series[2].data = this.flushData(this.randomData(data3, index))
        }, 1000 * 5)
      },
      immediate: true,
      deep: true
    }
  },
  beforeRouteLeave(to, from, next) {
    clearInterval(this.timer)
    next()
  },
  methods: {
    randomData(data, index) {
      data.forEach(item => {
        item.selected = false
      })
      data[index].selected = true
      return data
    },
    flushData(data) {
      data.forEach(item => {
        item.labelLine = {
          show: item.selected,
          normal: {
            length: 8,
            lineStyle: item.selected ? { color: '#fff' } : { color: 'rgba(255,0,0,0)' }
          }
        }
      })
      return data
    }
  }
}
</script>

<style lang="less" scoped>
  .rank-two{
    width: 100%;
    height: 294px;
    background: url("../../images/middle-2.png") top left no-repeat;
    background-size: 100% 100%;
    display: flex;
    justify-content: flex-start;
    position: relative;
    .m-left{
      padding: 20px 10px 20px 20px;
    }
    .center-one{
      left: 121px;
    }
    .center-two{
      left: 399px;
    }
    .center-three{
      left: 677px;
    }
    .center-one, .center-two, .center-three{
      position: absolute;
      top: 67px;
    }
    .ring-name{
      font-size: 24px;
      position: absolute;
      top: 230px;
      color: #fff;
    }
    .ring-one{
      left: 175px;
    }
    .ring-two{
      left: 438px;
    }
    .ring-three{
      left: 734px;
    }
  }
  .left{
    position: relative;
    top: -6px;
  }
</style>
